var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 732.4 732.4",
    style: {
      enableBackground: "new 0 0 732.4 732.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#757575;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M662.7,13.5L491.3,345.8c1,0.3,2,0.6,2.9,0.9c7.2,2.3,14,5.2,20.4,8.5c7.6,4,14.6,8.8,20.8,14.2L707.1,36.5 c6.3-12.3,1.5-27.4-10.8-33.7C684.1-3.5,669,1.3,662.7,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.6,629.7c27.2,24.6,60.7,46,99.4,63.6c65.4,29.8,122.9,38.6,125.4,39c0.1,0,0.1,0,0.2,0 c0.8,0.1,1.5,0.2,2.3,0.2c0.2,0,0.4,0,0.6,0c68.8-2.2,122.4-25.2,159.4-68.1c48.6-56.5,66.2-141.4,62.7-214.4 c-1-20.9-8.4-42.2-23-57.5c-1.1-1.1-2.2-2.2-3.4-3.3c-5.1-4.7-10.9-8.6-17-11.8c-5.3-2.8-10.9-5.1-16.5-6.9 c-2.4-0.8-4.7-1.3-7.1-1.8c-3.3-0.6-6.6-0.9-9.8-0.9c-24.1,0-47.2,15.2-64.9,30.6c-18.2,16-36.8,33.4-57.4,47.1 c-22.6,15-47.4,22.5-73.2,29.9c-33.4,9.5-67.6,15.6-102.1,19.4c-30.6,3.4-61.6,5.4-92.6,5.4c-12.3,0-24.5-0.3-36.8-1 c-0.7,0-1.4-0.1-2.1-0.1c-0.4,0-0.8,0-1.2,0c-5.3,0-10.2,2.4-13.5,6.6c-3.5,4.5-4.4,10.5-2.6,15.9 C37.4,562.1,62,598.5,96.6,629.7z M496.2,520.6c4.1,1.5,6.6,5.5,6.1,9.8c-3.9,34.3-15.1,78-44.3,111.9 c-30,34.7-74.2,53.6-131.6,56c-0.2,0-0.4,0-0.5,0c-0.7,0-1.5-0.1-2.2-0.2c-5.8-1-20-3.8-39.2-9c5.5-2.4,11.1-5.3,16.8-8.5 c5.1-2.9,10.3-6,15.4-9.3c15.8-10.2,31-21.7,42.9-31.2c2.7-2.2,0.2-6.5-3.1-5.1c-26,10.9-59.2,18.2-88.9,23 c-9.3,1.5-18.3,2.8-26.6,3.8c-9.7,1.2-18.5,2.2-25.8,2.9c-1.9-0.8-3.8-1.7-5.8-2.6c-16.5-7.6-31.9-15.9-46.2-24.8 c6.2-0.6,12.8-1.6,19.4-3c6-1.2,12.1-2.7,18.1-4.3c17.7-4.8,34.5-10.9,45.9-15.3c2.2-0.8,1.4-4.1-0.9-3.9 c-20.9,2-49.9,2.2-74.7,1.8c-8.1-0.1-15.8-0.3-22.5-0.5c-8.9-0.3-16.3-0.5-21.1-0.7c-2.8-2.4-5.6-4.8-8.3-7.2 c-3.5-3.2-6.9-6.4-10.1-9.7c5-0.5,10.2-1.3,15.5-2.3c5-0.9,10-2.1,15-3.3c19.7-5,39-11.9,51.7-16.8c2.2-0.8,1.4-4.1-0.9-3.9 c-19.6,1.9-46.4,2.2-70.1,1.9c-5.8-0.1-11.5-0.2-16.8-0.3c-5.9-0.1-11.4-0.3-16.3-0.4c-6.9-9.2-13-18.6-18.2-28.5 c-1.8-3.2,0.5-6.8,3.9-6.8l0,0c1.7,0,3.5,0,5.3,0c25,0,59.9-1.1,99-5.6c82.7-9.4,150.2-29.5,201.2-60c1.5-0.9,3.1-1.3,4.7-1.3 c1.5,0,3.1,0.4,4.5,1.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 621.2,
    cy: 619.7,
    r: 40.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 534.7,
    cy: 711.6,
    r: 20.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 644.6,
    cy: 707,
    r: 20.3
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroom);
export default __webpack_public_path__ + "static/media/broom.63b73ecee6c94021ee1289a96eea6605.svg";
export { ForwardRef as ReactComponent };